module.exports = __webpack_public_path__ + "static/img/A (14).50fdfb4f.png";